// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Popover from "../overlays/Popover.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as InputSearch from "./InputSearch.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SearchListItem from "./SearchListItem.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
let styles = {
  wrapper: {
    "alignSelf-kSGwAc": "alignSelf-xqcrz7y",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/resources/selection-and-input/SearchListPopover.res.js:20"
  }
};
function wrapperStyleFromParams(expendableWidth) {
  if (expendableWidth) {
    return {
      width: "100%"
    };
  } else {
    return {};
  }
}
function SearchListPopover(props) {
  let renderEndActions = props.renderEndActions;
  let __renderEndItem = props.renderEndItem;
  let onEndReached = props.onEndReached;
  let onToggle = props.onToggle;
  let onChange = props.onChange;
  let onSearchQueryChange = props.onSearchQueryChange;
  let __searchQueryDelay = props.searchQueryDelay;
  let opened = props.opened;
  let itemToOption = props.itemToOption;
  let itemToValue = props.itemToValue;
  let items = props.items;
  let expendableWidth = props.expendableWidth;
  let searchQueryDelay = __searchQueryDelay !== undefined ? __searchQueryDelay : 400;
  let renderEndItem = __renderEndItem !== undefined ? __renderEndItem : () => null;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = React.useState(() => "");
  let setSearchQuery = match$1[1];
  let searchQuery = match$1[0];
  let debouncedSearchQuery = ReactUpdateDebounced.use(searchQuery, searchQueryDelay);
  let textInputRef = React.useRef(null);
  let itemsListRef = React.useRef(null);
  React.useEffect(() => {
    if (opened !== undefined && !opened) {
      popover.close();
    }
  }, [opened]);
  React.useEffect(() => {
    let domElement = ReactDomElement.fromRef(itemsListRef);
    let handler = param => {
      Stdlib_Option.map(domElement, domElement => {
        let offsetY = domElement.scrollHeight;
        let scrolledY = domElement.scrollTop + domElement.offsetHeight;
        let offsetFromEndReached = offsetY - (scrolledY | 0) | 0;
        if (offsetFromEndReached < 100) {
          return onEndReached(offsetFromEndReached);
        }
      });
    };
    Stdlib_Option.map(domElement, domElement => {
      domElement.addEventListener("scroll", handler);
    });
    return () => {
      Stdlib_Option.map(domElement, domElement => {
        domElement.removeEventListener("scroll", handler);
      });
    };
  }, [itemsListRef.current]);
  React.useEffect(() => {
    onToggle(popover.isOpen);
  }, [popover.isOpen, textInputRef.current]);
  React.useEffect(() => {
    if (onSearchQueryChange !== undefined) {
      onSearchQueryChange(debouncedSearchQuery);
    }
  }, [debouncedSearchQuery]);
  let renderedItems = React.useMemo(() => {
    if (items !== undefined) {
      return items.map((item, index) => JsxRuntime.jsx(SearchListItem.make, {
        name: itemToOption(item),
        onPress: () => {
          onChange(item);
          popover.toggle();
        }
      }, itemToValue(item) + index.toString()));
    } else {
      return [];
    }
  }, [items]);
  let newrecord = {
    ...Stylex.props(styles.wrapper, wrapperStyleFromParams(expendableWidth))
  };
  let tmp;
  if (popover.isOpen) {
    let tmp$1;
    if (items !== undefined) {
      let newrecord$1 = {
        ...{
          className: "borderBottomLeftRadius-xgtq5j1 borderBottomRightRadius-x1w61mk2 borderTopColor-x7i6r9d borderTopStyle-x13fuv20 borderTopWidth-x178xt8z maxHeight-x1a2x7xj overflow-xysyzu8",
          "data-style-src": "wino-gc:src/resources/selection-and-input/SearchListPopover.res.js:37"
        }
      };
      tmp$1 = JsxRuntime.jsxs("div", (newrecord$1.ref = Primitive_option.some(itemsListRef), newrecord$1.children = [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Search results"),
          variation: "normal",
          size: "xxsmall"
        }),
        spaceX: "xnormal",
        spaceTop: "small",
        spaceBottom: "xxsmall"
      }), Belt_Array.concatMany([renderedItems, [JsxRuntime.jsx("div", {
        children: renderEndItem()
      }, "end-list-item")]]), renderEndActions !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Other suggestions"),
            variation: "normal",
            size: "xxsmall"
          }),
          spaceTop: "xsmall",
          spaceBottom: "xxsmall",
          spaceLeft: "xnormal"
        }), renderEndActions().map((element, index) => JsxRuntime.jsx("div", {
          children: element
        }, index.toString())), JsxRuntime.jsx(Box.make, {
          spaceBottom: "xsmall"
        })]
      }) : null], newrecord$1));
    } else {
      let newrecord$2 = {
        ...{
          className: "borderBottomLeftRadius-xgtq5j1 borderBottomRightRadius-x1w61mk2 borderTopColor-x7i6r9d borderTopStyle-x13fuv20 borderTopWidth-x178xt8z maxHeight-x1a2x7xj overflow-xysyzu8",
          "data-style-src": "wino-gc:src/resources/selection-and-input/SearchListPopover.res.js:37"
        }
      };
      tmp$1 = JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(SearchListItem.make, {
        children: renderEndItem()
      }, "end-list-item"), newrecord$2));
    }
    tmp = JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsxs(Popover.Dialog.make, {
        children: [JsxRuntime.jsx(InputSearch.make, {
          loading: Stdlib_Option.isNone(items),
          onRequestClear: () => setSearchQuery(param => ""),
          bordered: false,
          placeholder: I18n.t("Search"),
          autoFocus: true,
          value: searchQuery,
          onChange: searchQuery => setSearchQuery(param => searchQuery)
        }), tmp$1],
        ariaProps: popoverAriaProps.overlayProps,
        style: {
          minWidth: "200px"
        }
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom start",
      layout: expendableWidth ? "triggerMinWidth" : "auto",
      modal: false
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Touchable.make, {
      children: props.children,
      ariaProps: popoverAriaProps.triggerProps,
      onPress: param => popover.toggle(),
      ref: popoverTriggerRef
    }), newrecord)), tmp]
  });
}
let make = SearchListPopover;
export { make };
/* styles Not a pure module */